import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FN02 {
  fn02_01: string;        // 客訴說明文字 (PK, max 50 chars)
  fn02_91: string;        // 建立人員代號
  fn02_92: string | null; // 建立/修改日期
  fn02_93: string;        // 修改人員代號
}

export interface CreateRequest {
  fn02_01: string;
}

export interface UpdateRequest {
  fn02_01: string;
}

export interface ListResponse {
  data: FN02[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const complaintDescApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/complaint-desc', { params });
    return res.data;
  },

  async get(code: string): Promise<FN02> {
    const res = await apiClient.get(`/api/complaint-desc/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FN02> {
    const res = await apiClient.post('/api/complaint-desc', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<FN02> {
    const res = await apiClient.put(`/api/complaint-desc/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/complaint-desc/${encodeURIComponent(code)}`);
  },
};
